module.exports = __webpack_public_path__ + "img/img (22).33b73c12.jpg";